import { useEffect } from 'react'
import { Outlet, useMatches } from 'react-router'
import { TopBar } from './TopBar'
import { SideNav } from './SideNav'
import { Breadcrumbs } from './Breadcrumbs'
import { MenuAccessGuard } from './MenuAccessGuard'
import { applyFontScale, clearFontScale, loadFontScale } from './font-scale'

/**
 * v2 (AWS Console 스타일) 셸 — 탑바 + 사이드네비 + 브레드크럼 + 콘텐츠.
 * html에 .v2 클래스를 토글해 shadcn 토큰을 AWS 팔레트로 재테마한다
 * (Radix portal이 body로 탈출해도 상속되도록 html 레벨에 건다).
 */
export function V2Layout() {
  const matches = useMatches()
  const title = (matches.at(-1)?.handle as { title?: string } | undefined)?.title

  useEffect(() => {
    document.title = title ? `${title} — Fiket Admin` : 'Fiket Admin'
  }, [title])

  useEffect(() => {
    document.documentElement.classList.add('v2')
    // 저장된 글자 크기 단계를 클래스와 같은 타이밍에 반영해 크기 점프를 막는다
    applyFontScale(loadFontScale())
    return () => {
      document.documentElement.classList.remove('v2')
      clearFontScale()
    }
  }, [])

  return (
    <div className="flex min-h-screen flex-col bg-[#f2f3f3] text-[#16191f]">
      <TopBar />
      <div className="flex flex-1 items-start">
        <SideNav />
        <main className="min-w-0 flex-1">
          <div className="w-full px-4 py-4 sm:px-6">
            <Breadcrumbs />
            {/* 메뉴 권한 가드 (FIKET-417) — 보기 권한 없음 패널 / 읽기 전용 배너 */}
            <MenuAccessGuard>
              <Outlet />
            </MenuAccessGuard>
          </div>
        </main>
      </div>
    </div>
  )
}
